export class Proofs {
	allDay?: boolean;
	repeat?: boolean;
	startDate?: Date;
	endDate?: Date;
	frequency?: string;
	repeatInterval?: number;
	weekDays?: number[];
	monthlyByWeekDay?: boolean;

	companyId?: string;
	companyName?: string;
	departmentId?: string;
	departmentName?: string;
	gender?: string;
	name?: string;
	userId?: string;

	proofType?: string;
	date?: Date;
	fileName?: string;
  proofsCount: number;
}

export class ProofsType {
  id: string;
  medicalCertificate: boolean;
  type: string;
}

export interface ProofPageableResponse {
	proofs: Proofs[];
	count: number;
}

export enum ProofStatus {
		APPROVED= "APPROVED",
		PENDING= "PENDING",
		REJECTED= "REJECTED"
	}
export enum ProofDocumentTypes {
		DOCUMENT= "DOCUMENT",
		IMAGE= "IMAGE",
		VIDEO= "VIDEO"
	}

export	type ProofData = {
		contentType: string;
		fileName: string;
		fileUrl: string;
		status: ProofStatus;
		type: ProofDocumentTypes;
		uploadedAt: string; // Consider `Date` if parsing is needed
		userId: string;
	  };
	  
export type ProofResponse = ProofData[];


export type ProofValidatePayload = {
	fileUrl: string;
	status: ProofStatus;
	userId: string;
}

export type ProofValidatePayloadResponse = {

}